<div class="filter" (click)="opemModal()" [ngClass]="{'selected': selected}">
  <span>
    {{name}}
    @if (lenght != 0) {
      <label>({{lenght}})</label>
    }
  </span>
  <mat-icon aria-hidden="false" aria-label="Menu apps">arrow_drop_down</mat-icon>
</div>